export default {
  en: {
    title: "Smart Routing",
    tab_last_agent: "Last Agent Routing",
    tab_vip: "VIP Numbers",
    tab_blacklist: "Blacklist",
    last_agent: {
      title: "Last Agent Routing",
      description:
        "Route repeat callers to the agent who last served them when that agent is available.",
      enabled: "Enabled",
      disabled: "Disabled",
      window_label: "Lookback Window (minutes)",
      window_hint:
        "How far back, in minutes, to look for the agent who last served the caller",
      window_error: "Enter a whole number of minutes greater than 0",
      minutes: "minutes",
      queue_label: "Queue",
      queue_hint:
        "Choose a specific queue, or apply the configuration to all queues",
      all_queues: "All Queues",
      apply_btn: "Apply",
      apply_success: "Last agent routing configuration saved",
      apply_error: "Failed to save last agent routing configuration",
    },
    lists: {
      vip_title: "VIP Numbers",
      vip_description:
        "VIP numbers are prioritized in queues — numbers higher in the list are served first.",
      vip_order_hint: "Use the arrows to reorder; the top number is served first.",
      blacklist_title: "Blacklist",
      blacklist_description: "Blacklisted numbers are blocked from calling in.",
      search_label: "Search number",
      add_btn: "Add Number",
      head_number: "Number",
      head_comment: "Comment",
      head_actions: "Actions",
      empty_vip: "No VIP numbers yet",
      empty_blacklist: "No blacklisted numbers yet",
      add_vip_title: "Add VIP Number",
      add_blacklist_title: "Add Number to Blacklist",
      number_label: "Number",
      number_invalid: "Enter a valid number (3-20 digits, may start with +)",
      added_on_top_hint: "The number will be added to the top of the list.",
      comment_label: "Comment (optional)",
      add_confirm_btn: "Add",
      move_up: "Move up",
      move_down: "Move down",
      delete_title: "Delete Number",
      delete_vip_text: "Remove {number} from the VIP list?",
      delete_blacklist_text:
        "Remove {number} from the blacklist? It will no longer be blocked.",
      delete_confirm_btn: "Delete",
      delete_cancel_btn: "Cancel",
      added_success: "Number added",
      deleted_success: "Number deleted",
    },
  },
  ar: {
    title: "التوجيه الذكي",
    tab_last_agent: "التوجيه لآخر موظف",
    tab_vip: "الأرقام المميزة (VIP)",
    tab_blacklist: "الأرقام المحظورة",
    last_agent: {
      title: "التوجيه لآخر موظف",
      description:
        "عند اتصال العميل مجددًا يتم توجيهه إلى آخر موظف قام بخدمته إذا كان متاحًا.",
      enabled: "مفعّل",
      disabled: "غير مفعّل",
      window_label: "الفترة الزمنية (بالدقائق)",
      window_hint:
        "المدة التي يتم خلالها البحث عن آخر موظف خدم العميل، محسوبة بالدقائق",
      window_error: "أدخل عددًا صحيحًا من الدقائق أكبر من صفر",
      minutes: "دقيقة",
      queue_label: "المجموعة",
      queue_hint: "اختر مجموعة محددة أو طبّق الإعداد على جميع المجموعات",
      all_queues: "جميع المجموعات",
      apply_btn: "حفظ",
      apply_success: "تم حفظ إعدادات التوجيه بنجاح",
      apply_error: "تعذّر حفظ إعدادات التوجيه",
    },
    lists: {
      vip_title: "الأرقام المميزة (VIP)",
      vip_description:
        "تحظى هذه الأرقام بأولوية في الانتظار، والأرقام الأعلى في القائمة تُخدم أولًا.",
      vip_order_hint: "استخدم الأسهم لتغيير الترتيب، فالرقم الأعلى يُخدم أولًا.",
      blacklist_title: "الأرقام المحظورة",
      blacklist_description: "يُمنع أصحاب هذه الأرقام من الاتصال بمركز الاتصال.",
      search_label: "ابحث برقم الهاتف",
      add_btn: "إضافة رقم",
      head_number: "الرقم",
      head_comment: "ملاحظة",
      head_actions: "الإجراءات",
      empty_vip: "لم تُضف أي أرقام مميزة بعد",
      empty_blacklist: "لا توجد أرقام محظورة",
      add_vip_title: "إضافة رقم مميز",
      add_blacklist_title: "حظر رقم جديد",
      number_label: "رقم الهاتف",
      number_invalid: "أدخل رقم هاتف صحيحًا",
      added_on_top_hint: "سيُضاف الرقم في أعلى القائمة.",
      comment_label: "ملاحظة (اختياري)",
      add_confirm_btn: "إضافة",
      move_up: "تحريك لأعلى",
      move_down: "تحريك لأسفل",
      delete_title: "حذف الرقم",
      delete_vip_text: "هل تريد إزالة الرقم {number} من قائمة الأرقام المميزة؟",
      delete_blacklist_text:
        "هل تريد إزالة الرقم {number} من قائمة الحظر؟ سيتمكن صاحبه من الاتصال مجددًا.",
      delete_confirm_btn: "حذف",
      delete_cancel_btn: "إلغاء",
      added_success: "تمت إضافة الرقم بنجاح",
      deleted_success: "تم حذف الرقم",
    },
  },
};
